import { RadioButtonWithLabelOption, TextLinkWidget } from '@tableau/widgets';
import { useFormikContext } from 'formik';
import * as React from 'react';

import { FormikRadioButtonGroup } from '~commonInfra/components/FormikRadioButtonGroup';
import { HelpService } from '~commonInfra/services/HelpService';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { learnMoreStyle, settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { AskDataMode } from '../../../../types/AskDataMode';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const ASK_DATA_SECTION_TEST_ID = 'ask-data-site-setting';
export const ASK_DATA_LEARN_MORE_TEST_ID = 'ask-data-learn-more';
export const ASK_DATA_MODE_ENABLED_BUTTON_TEST_ID = 'ask-data-mode-enabled';
export const ASK_DATA_MODE_DISABLED_BUTTON_TEST_ID = 'ask-data-mode-disabled';
export const ASK_DATA_MODE_ALWAYS_DISABLED_BUTTON_TEST_ID = 'ask-data-mode-disabled-always';

export type AskDataSectionProps = SiteSettingsForSiteAdminProps<'askDataMode'>;

export function AskDataSection(props: AskDataSectionProps) {
  const formik = useFormikContext<AskDataSectionProps>();
  const { buttonList, className } = React.useMemo(() => getButtonListAndClassName(formik.values), [formik.values]);
  return (
    <SettingsSection
      title={Messages.nlpSwitchSiteSettingTitle()}
      testId={ASK_DATA_SECTION_TEST_ID}
    >
      <FormikRadioButtonGroup
        aria-label={Messages.nlpSwitchSiteSettingTitle()}
        buttonList={buttonList}
        className={className}
        name={'settings.askDataMode'}
      />
    </SettingsSection>
  );
}

function getButtonListAndClassName(props: AskDataSectionProps) {
  const askDataModeEnabledButtonLabel = <>
    <div>{Messages.AskData_enabled()}</div>
    <div>{Messages.nlpEnabledLensesDescription()}</div>
  </>;
  const askDataModeDisabledButtonLabel = <>
    <div>{Messages.AskData_disabled()}</div>
    <div>{Messages.nlpDisabledLensesDescription()}
    <TextLinkWidget
        className={learnMoreStyle}
        href={HelpService.getServerHelpUrlByCategory('ask-data-site-setting')}
        target='_blank'
        testId={ASK_DATA_LEARN_MORE_TEST_ID}
      >
      {Messages.learnMore()}
    </TextLinkWidget>
    </div>
  </>;

  let buttonList: RadioButtonWithLabelOption<AskDataMode>[] = [
    {
      value: AskDataMode.DISABLED_BY_DEFAULT,
      label: askDataModeEnabledButtonLabel,
      testId: ASK_DATA_MODE_ENABLED_BUTTON_TEST_ID
    },
    {
      value: AskDataMode.DISABLED_ALWAYS,
      label: askDataModeDisabledButtonLabel,
      testId: ASK_DATA_MODE_DISABLED_BUTTON_TEST_ID
    }
  ];

  let className: string = settingsRadioButtonItemHeight;

  return { buttonList, className };
}

/* for registering the component in settings registry */
export const AskDataSectionSpecs = componentRegistryEntry({
  name: 'AskDataSection',
  component: AskDataSection
});
